import { action, computed, makeAutoObservable } from "mobx";

export class AuthenticationStore {
  private address: string = "NONE";
  private authenticated: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  setAddress(newAddress: string) {
    this.address = newAddress;
  }

  @action
  setAuthenticationStatus(authenticated: boolean) {
    this.authenticated = authenticated;
  }

  @computed
  getAuthStatus(): boolean {
    return this.authenticated;
  }

  @computed
  getAddress(): string {
    return this.address;
  }
}
